import { render, staticRenderFns } from "./MaintenanceCard.vue?vue&type=template&id=4c0c09dd"
import script from "./MaintenanceCard.vue?vue&type=script&lang=js"
export * from "./MaintenanceCard.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceCard.vue?vue&type=style&index=0&id=4c0c09dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
